// Declare app level module which depends on views, and components
angular.module('quattro.bmbo', [
    'ngRoute',
    'pascalprecht.translate',
    'ngCsv',

    'templates-app_core',
    'templates-app_bmbo',

    'quattro.config',

    // 'quattro.core.filters',
    'quattro.core.hpls_api_1',
    'quattro.core.hpls-api-validation',
    'quattro.core.alert',
    'quattro.core.crumbs',
    'quattro.core.user',
    'quattro.core.form-helper',

    'quattro.bmbo.search',

    'quattro.bmbo.index',
    'quattro.bmbo.login.password-reset',
    'quattro.bmbo.login.password-set',

    'quattro.bmbo.admin.dashboard',
    'quattro.bmbo.admin.accounts',

    'quattro.bmbo.account.create',
    'quattro.bmbo.account.view',
    'quattro.bmbo.account.edit',

    'quattro.bmbo.mailinglist.view',
    'quattro.bmbo.mailinglist.edit',

    'quattro.bmbo.domain.view',
    'quattro.bmbo.domain.edit',

    'quattro.bmbo.email.view',
    'quattro.bmbo.email.edit',
])
    .config(function ($routeProvider, $translateProvider) {

        // custom route object extensions:
        // - `auth`
        // - `bodyClass`: class name for body tag
        // - `crumbClass`: class name for breadcrumb container

        $routeProvider
            .when("/", {
                template: "loading...",
                controller: 'IndexController',
            })

            .when('/login', {
                templateUrl: 'bmbo/login/login.html',
                controller: 'LoginController'
            })
            .when('/logout', {
                template: 'logging out...',
                controller: 'LogoutController'
            })
            .when('/password/reset', {
                templateUrl: 'bmbo/login/password-reset.html',
                controller: 'BmboPasswordResetController',
                controllerAs: 'vm',
            })
            .when('/password/set/:key', {
                templateUrl: 'bmbo/login/password-set.html',
                controller: 'BmboPasswordSetController',
                controllerAs: 'vm',
            })

            .when('/dashboard', {
                templateUrl: 'bmbo/admin/dashboard.html',
                controller: 'BmboAdminDashboardController',
                bodyClass: 'dashboard',
                crumbClass: 'dashboard',
            })
            .when('/admin/accounts', {
                templateUrl: 'bmbo/admin/accounts.html',
                controller: 'BmboAdminAccountsController',
                controllerAs: 'vm',
            })

            .when('/account=:account', {
                templateUrl: 'bmbo/account/view.html',
                controller: 'BmboAccountController',
                controllerAs: 'vm',
                crumbClass: 'account',
            })
            .when('/account/create', {
                templateUrl: 'bmbo/account/create.html',
                controller: 'CreateAccountController',
                controllerAs: 'vm',
                crumbClass: 'account',
            })
            .when('/account=:account/edit/:section?', {
                templateUrl: 'bmbo/account/edit.html',
                controller: 'BmboAccountEditController',
                controllerAs: 'vm',
                crumbClass: 'account edit',
            })

            .when('/account=:account/mailinglist=:mailinglist', {
                templateUrl: 'bmbo/mailinglist/view.html',
                controller: 'BmboMailinglistController',
                controllerAs: 'vm',
                crumbClass: 'mailinglist',
            })
            .when('/account=:account/mailinglist=:mailinglist/edit/:section?', {
                templateUrl: 'bmbo/mailinglist/edit.html',
                controller: 'BmboMailinglistEditController',
                controllerAs: 'vm',
                crumbClass: 'mailinglist edit',
            })

            .when('/account=:account/domain=:domain', {
                templateUrl: 'bmbo/domain/view.html',
                controller: 'BmboDomainController',
                controllerAs: 'vm',
                crumbClass: 'domain',
            })
            .when('/account=:account/domain=:domain/edit/:section?', {
                templateUrl: 'bmbo/domain/edit.html',
                controller: 'BmboDomainEditController',
                controllerAs: 'vm',
                crumbClass: 'domain edit',
            })

            .when('/account=:account/domain=:domain/email=:email?', {
                templateUrl: 'bmbo/email/view.html',
                controller: 'BmboEmailController',
                controllerAs: 'vm',
                crumbClass: 'email',
            })
            .when('/account=:account/domain=:domain/email=:email?/edit', {
                templateUrl: 'bmbo/email/edit.html',
                controller: 'BmboEmailEditController',
                controllerAs: 'vm',
                crumbClass: 'email edit',
            })

            .when('/search/:query', {
                templateUrl: 'bmbo/search/search.html',
                controller: 'SearchController',
                controllerAs: 'vm',
                bodyClass: 'route-search',
                reloadOnSearch: false,
            })

            .when('/404', {
                template: '<h1>404</h1>',
                controller: function () {
                },
            })
            .otherwise({
                redirectTo: '/404',
            });

        $translateProvider.useStaticFilesLoader({
            prefix: 'lang/bmbo-',
            suffix: '.json'
        });
        $translateProvider.preferredLanguage('de_DE');
        $translateProvider.useSanitizeValueStrategy('escapeParameters');
    })
    .run(function ($rootScope, $location, userService, crumbService) {

        $rootScope.crumbs = crumbService.scope;
        $rootScope.user = userService.scope;

        $rootScope.$on("$routeChangeStart", function (event, next) {

            var nextRoute = next && next.$$route;

            if (!nextRoute) {
                return; // early exit
            }

            // check authentication
            var auth = nextRoute.auth;
            var userName = userService.get('userName');
            var userLevel = userService.get('userLevel');
            if (auth && !auth(userName, userLevel)) {
                $location.path('/login');
            }
        });

        $rootScope.$on("$routeChangeSuccess", function (event, next) {

            var nextRoute = next.$$route || {};
            var params = next.params;

            var bodyClass = nextRoute.bodyClass || '';
            var crumbClass = nextRoute.crumbClass || '';

            $rootScope.bodyClass = bodyClass;

            // set breadcrumb w/ url route data
            crumbService.setRouteParams(params, crumbClass);
        });
    })
    .config(function (apiProvider, bmbo_api_url) {
        apiProvider.id = 'quattro';
        apiProvider.url = bmbo_api_url;
    })
    .run(function (api, userService) {
        // validate user session
        api
            .single({method: 'hello.innerworld', params: {}})
            .then(null, userService.sessionExpired);
    })
    .controller('MainCtrl', function ($scope, $translate, api) {

        $scope.api = api.scope;

        $scope.switchLanguage = function (key) {
            $translate.use(key);
        };
    });
